import { type WorkoutSetType } from "api-client";
import { cn } from "ui";

import { getWorkoutSetTypeOption } from "src/workouts/workoutSetType";

interface WorkoutSetLabelProps {
  type: WorkoutSetType | null | undefined;
  setNumber: number;
}

export function WorkoutSetLabel(props: WorkoutSetLabelProps) {
  if (!props.type) {
    return <span>{props.setNumber}</span>;
  }

  const option = getWorkoutSetTypeOption(props.type);

  return (
    <span className={cn("font-semibold", option.className)}>
      {option.letter}
    </span>
  );
}
